function popupClose() {
    trigger = false;

    $(".popup").hide();

    Cookies.set('popup', 'hidden', { sameSite: true });
}

$(document).ready(function() {

    var popup = Cookies.get('popup');

    if (popup == 'hidden') {

    } else {

        setTimeout(function(){
          $(".popup").fadeIn();
        }, 5000);
    }

});

$(".mobile-menu--toggle").click(function() {
    $(".mobile-menu").fadeIn();
});
